import React from "react";
import Our from "./Our/Our";
import Product from "./Product/Product";

const Shop = () => {
  return (
    <>
      <Our />
      <Product />
    </>
  );
};

export default Shop;
